import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "searchFilter",
  class: "w-full max-w-xl"
}
const _hoisted_2 = { class: "relative rounded-xl shadow-sm overflow-hidden" }
const _hoisted_3 = ["placeholder"]

import { ref } from "vue";
import { debounce } from "lodash";

import { DEBOUNCE_DELAY } from "@/api/config";
import i18n from "@/services/i18n";
import { CloseOutlined } from "@ant-design/icons-vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'SearchFilter',
  emits: ["search"],
  setup(__props, { emit: __emit }) {

const searchValue = ref("");
const emit = __emit;
const debouncedEmit = debounce(() => {
  emit("search", searchValue.value);
}, DEBOUNCE_DELAY);
const onInput = () => {
  debouncedEmit();
};
const clearSearch = () => {
  searchValue.value = "";
  debouncedEmit();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
        onInput: onInput,
        placeholder: _unref(i18n).global.t('SEARCH_SECTION.TITLE'),
        class: "w-full px-4 py-2 pr-10 text-gray-800 placeholder-gray-400 bg-white border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-blue-600 transition-all duration-200"
      }, null, 40, _hoisted_3), [
        [_vModelText, searchValue.value]
      ]),
      (searchValue.value)
        ? (_openBlock(), _createBlock(_unref(CloseOutlined), {
            key: 0,
            onClick: clearSearch,
            class: "absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 cursor-pointer text-lg"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})